import { render, staticRenderFns } from "./HowGlovelerWorks.vue?vue&type=template&id=12c8a509&scoped=true"
import script from "./HowGlovelerWorks.vue?vue&type=script&lang=js"
export * from "./HowGlovelerWorks.vue?vue&type=script&lang=js"
import style0 from "./HowGlovelerWorks.vue?vue&type=style&index=0&id=12c8a509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8a509",
  null
  
)

export default component.exports